/**
 * Shared fetch helper for hand-written REST clients in `src/api/rest/`.
 * Orval-generated hooks use `customFetch` directly; manual clients use this
 * thin wrapper to unwrap the `{ data, status, headers }` envelope and set
 * a JSON Content-Type when there's a body without one.
 */
import { customFetch } from "./custom-fetcher";

export const BASECAMP_API_BASE = "/api/basecamp";

type ApiResponse<T> = { data: T; status: number; headers: Headers };

export async function apiFetch<T>(url: string, options?: RequestInit): Promise<T> {
  const headers = new Headers(options?.headers);
  if (options?.body && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }
  const res = await customFetch<ApiResponse<T>>(url, { ...options, headers });
  if (res.status < 200 || res.status >= 300) {
    throw new Error(`HTTP ${res.status}`);
  }
  return res.data;
}
